import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`

const Title = styled.h3`
  margin: 0;
  color: ${props => props.theme.blackShade};
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.5px;
`

const Content = styled.div`
  ul {
    padding-left: 24px;
  }
  h4 {
    color: #212121;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }
  p {
    color: ${props => props.blackShade};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
  li {
    color: ${props => props.blackShade};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
  }
`

const NonStandardCancellation = ({ terms }) => {
  return (
    <Wrapper>
      <Title>Non-Standard Cancellation</Title>
      <Content dangerouslySetInnerHTML={{ __html: terms }} />
    </Wrapper>
  )
}

NonStandardCancellation.propTypes = {
  accommodation: PropTypes.array,
}

export default NonStandardCancellation
